<template>
    <form>
        <div class="form-group">
            <label class="control-label">
                Text Field
            </label>
            <div class="form-group__input">
                <input type="text"
                       class="form-control input-lg" />
            </div>
        </div>

        <div class="form-group">
            <label class="control-label">
                Text Field<small class="required-label">{{ l('REQUIRED') }}</small>
            </label>
            <div class="form-group__input">
                <input type="text"
                       class="form-control input-lg" />
            </div>
        </div>

        <div class="form-group">
            <label class="control-label">
                Full Name
            </label>
            <div class="form-group__input">
                <input type="text"
                       class="form-control input-lg"
                       placeholder="First Name" />
                <input type="text"
                       class="form-control input-lg"
                       placeholder="Last Name" />
            </div>
        </div>

        <div class="form-group">
            <label class="control-label">
                Select
            </label>
            <div class="form-group__input">
                <select class="form-control input-lg">
                    <option v-for="option in selectOptions"
                            :key="option"
                            :value="option">
                        {{ option }}
                    </option>
                </select>
            </div>
        </div>

        <div class="form-group">
            <label class="control-label">
                Checkbox
            </label>
            <div class="form-group__checkboxes">
                <div class="form-group__checkbox">
                    <input type="checkbox"
                           class="form-control" />
                </div>
            </div>
        </div>

        <div class="form-group">
            <label class="control-label">
                Checkboxes
            </label>
            <div class="form-group__checkboxes">
                <label class="form-group__checkbox">
                    <input type="checkbox"
                           name="fruits"
                           value="apples"
                           class="form-control" />
                    I Like Apples
                </label>
                <label class="form-group__checkbox">
                    <input type="checkbox"
                           name="fruits"
                           value="bananas"
                           class="form-control" />
                    I Like Bananas
                </label>
                <label class="form-group__checkbox">
                    <input type="checkbox"
                           name="fruits"
                           value="coconuts"
                           class="form-control" />
                    I Like Coconuts
                </label>
                <label class="form-group__checkbox">
                    <input type="checkbox"
                           name="fruits"
                           value="dates"
                           class="form-control" />
                    I Like Dates
                </label>
            </div>
        </div>

        <div class="form-group">
            <label class="control-label">
                Radio Buttons
            </label>
            <div class="form-group__checkboxes">
                <label class="form-group__checkbox">
                    <input type="radio"
                           name="color"
                           value="red"
                           class="form-control" />
                    Make It Red
                </label>
                <label class="form-group__checkbox">
                    <input type="radio"
                           name="color"
                           value="green"
                           class="form-control" />
                    Make It Green
                </label>
                <label class="form-group__checkbox">
                    <input type="radio"
                           name="color"
                           value="yellow"
                           class="form-control" />
                    Make It Yellow
                </label>
                <label class="form-group__checkbox">
                    <input type="radio"
                           name="color"
                           value="blue"
                           class="form-control" />
                    Make It Blue
                </label>
            </div>
        </div>
    </form>
</template>

<script>
export default {
    data() {
        return {
            selectOptions: [
                'Aardvark',
                'Bison',
                'Cheetah',
                'Dolphin',
                'Elephant',
            ],
        };
    },
};
</script>
